const portalId = process.env.VUE_APP_PORTAL_ID || process.env.VUE_APP_PORTAL;

import samp from 'samp-npm';
import client from 'api-client';

let connector, clientTracker, isHubRunning = false,
  sampDestination = null,
  isSampRegistered = false;

let createTag = (function() {
  let count = 0;
  return function() {
    return "portal-msg-" + ++count;
  };
})();

function sendFile(data) {
  connector.runWithConnection(function(connection) {
    let msg = new samp.Message(data.mtype, {
      url: data.url
    });
    if (sampDestination) {
      connector.connection.call([sampDestination, createTag(), msg], function() {
        sampResponseComplete(data.mtype, data.url);
      });
    } else {
      connection.notifyAll([msg], function() {
        sampResponseComplete(data.mtype, data.url);
      });
    }
  });
}

function sampResponseComplete(mType, fileKey) {}

export default {
  namespaced: true,
  state: {
    hubRunning: false,
    registered: false,
    clients: []
  },
  mutations: {
    registerSamp: function(state) {
      connector.register();
      state.registered = true;
    },
    setHubRunning(state, value) {
      state.hubRunning = value;
    },
    sendFileBySamp: function(state, data) {
      if (state.hubRunning) {
        if (data.free) {
          sendFile(data);
        } else {
          let urlStart = data.url.indexOf('download?url=');
          if (urlStart !== -1) {
            data.url = decodeURIComponent(data.url.substring(urlStart + 'download?url='.length));
          }
          client.getSampDownloadUrl(data.url)
            .then(res => {
              data.url = res.url;
              sendFile(data);
            });
        }
      }
    },
    updatePageComponents(state) {
      if (state.hubRunning) {
        if (clientTracker) {
          state.register = !!clientTracker.connection;
          let ids = clientTracker.connection ? clientTracker.ids : {};

          state.clients = [];

          let destinationStillRunning = false;
          for (let id in ids) {
            let meta = clientTracker.metas[id];
            if (meta) {
              let name = meta["samp.name"];
              if (name) {
                let client = {
                  id,
                  name
                };
                let icon = meta["samp.icon.url"];
                if (icon) {
                  client.icon = icon;
                }
                client.selected = id === sampDestination;
                if (client.selected) {
                  destinationStillRunning = true;
                }
                state.clients.push(client);
              }
            }
          }
          if (!destinationStillRunning) {
            sampDestination = null;
          }
        }
      }
      for (let sampBtn of document.querySelectorAll('#result-table .send-by-samp-btn')) {
        sampBtn.classList.toggle('active', state.hubRunning)
      }
    }
  },
  actions: {
    sampInit({ commit }) {
      let baseUrl = location.href.replace(/[^/]*$/, "");

      let sampMeta = {
        "samp.name": portalId,
        "samp.description": "Portal SAMP" //,
        //"samp.icon.url": baseUrl + "clientIcon.gif"
      };

      clientTracker = new samp.ClientTracker();
      clientTracker.onchange = function(id, type, data) {
        commit('updatePageComponents');
      };
      clientTracker.calculateSubscriptions();

      let logCc = {
        receiveNotification: function(senderId, message) {
          clientTracker.receiveNotification(senderId, message);
        },
        receiveCall: function(senderId, msgId, message) {
          clientTracker.receiveCall(senderId, msgId, message);
        },
        receiveResponse: function(responderId, msgTag, response) {
          clientTracker.receiveResponse(responderId, msgTag, response);
        },
        init: function(connection) {
          clientTracker.init(connection);
        }
      };

      connector = new samp.Connector(portalId, sampMeta, logCc, {
        '*': {}
      });

      connector.onHubAvailability(function(value) {
        commit('setHubRunning', value);
        commit('updatePageComponents');
      }, 2000);

      window.onunload = window.onbeforeunload = function() {
        connector.unregister();
      };
    },
    setSampDestination({ commit }, id) {
      sampDestination = id;
      commit('updatePageComponents');
    },
  }
}
